import { Link } from "react-router-dom";

import { SiteLogoMark } from "@components";

function JetStreamVisual() {
  return (
    <div className="relative mx-auto mt-10 w-full max-w-3xl overflow-hidden rounded-2xl border border-line/25 bg-surface/50 px-2 py-6 shadow-glow animate-fade-up-delay">
      <svg
        viewBox="0 0 560 200"
        className="mx-auto block w-full max-w-2xl animate-drift"
        aria-label="Omega block jet stream diagram"
      >
        <defs>
          <linearGradient id="jetGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="var(--chart-jet)" stopOpacity="0.4" />
            <stop offset="50%" stopColor="var(--chart-high)" />
            <stop offset="100%" stopColor="var(--chart-jet)" stopOpacity="0.4" />
          </linearGradient>
        </defs>
        <path
          d="M 32 88 C 80 88, 100 32, 140 32 C 180 32, 200 88, 240 88 C 258 88, 262 118, 280 118 C 298 118, 302 88, 320 88 C 360 88, 380 32, 420 32 C 460 32, 480 88, 528 88"
          fill="none"
          stroke="url(#jetGrad)"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <ellipse cx="280" cy="98" rx="58" ry="24" fill="var(--chart-high)" fillOpacity="0.25" stroke="var(--chart-high)" />
        <text x="280" y="102" textAnchor="middle" fill="currentColor" className="fill-ink" fontSize="12" fontWeight="600">
          HIGH
        </text>
        <ellipse cx="140" cy="40" rx="38" ry="15" fill="var(--chart-low)" fillOpacity="0.45" stroke="var(--chart-low-ring)" />
        <text x="140" y="44" textAnchor="middle" fill="var(--chart-low-ring)" fontSize="10" fontWeight="600">
          LOW
        </text>
        <ellipse cx="420" cy="40" rx="38" ry="15" fill="var(--chart-low)" fillOpacity="0.45" stroke="var(--chart-low-ring)" />
        <text x="420" y="44" textAnchor="middle" fill="var(--chart-low-ring)" fontSize="10" fontWeight="600">
          LOW
        </text>
        <text
          x="280"
          y="186"
          textAnchor="middle"
          fill="currentColor"
          className="fill-faint"
          fontSize="11"
        >
          Omega block — weather trapped for days to weeks
        </text>
      </svg>
    </div>
  );
}

export const Hero = () => {
  return (
    <section className="relative overflow-hidden pb-8 pt-10 md:pt-16">
      <div className="pointer-events-none absolute -left-24 top-0 h-64 w-64 rounded-full bg-accent/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 top-24 h-56 w-56 rounded-full bg-navy/40 blur-3xl dark:bg-navy/50" />

      <div className="relative mx-auto max-w-4xl px-4 text-center">
        <p className="section-label animate-fade-up">Arboretum Labs · climate regime intelligence</p>

        <div className="mt-4 flex flex-col items-center gap-4 animate-fade-up">
          <SiteLogoMark className="h-16 w-16 sm:h-20 sm:w-20" />
          <h1 className="font-display text-5xl font-semibold tracking-tight text-ink sm:text-6xl md:text-7xl">
            whatIsUp
          </h1>
        </div>

        <p className="mx-auto mt-5 max-w-xl text-lg text-muted animate-fade-up-delay md:text-xl">
          Detecting atmospheric blocking regimes to improve decisions around
          persistent extreme-weather risk.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3 animate-fade-up-delay">
          <Link to="/explore" className="btn-primary">
            Explore
          </Link>
          <Link to="/science" className="btn-ghost">
            Understand the science
          </Link>
        </div>

        <JetStreamVisual />
      </div>
    </section>
  );
};
